type MergeDeep<T, U> = U extends object
  ? T extends object
    ? {
        [K in keyof T | keyof U]: K extends keyof U
          ? K extends keyof T
            ? MergeDeep<T[K], U[K]>
            : U[K]
          : K extends keyof T
            ? T[K]
            : never;
      }
    : U
  : U;

const isObject = (item: unknown): item is Record<string, any> => {
  return item !== null && typeof item === 'object' && !Array.isArray(item);
};

export const mergeDeep = <T, U extends object>(target: T, ...items: U[]): MergeDeep<T, U> => {
  if (!items.length) {
    return target as MergeDeep<T, U>;
  }
  const source = items.shift();
  if (!source) {
    return target as MergeDeep<T, U>;
  }
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key: string) => {
      const sourceValue = source[key as keyof typeof source];
      if (isObject(sourceValue)) {
        if (!(target as Record<string, any>)[key]) {
          Object.assign(target, {[key]: {}});
        }
        mergeDeep((target as Record<string, any>)[key], sourceValue);
      } else {
        Object.assign(target, {[key]: sourceValue});
      }
    });
  }
  return mergeDeep(target, ...items);
};
